<template>
  <div>
    <a-modal
        v-drag-modal
        wrap-class-name="custom-modal-wrap" 
        :visible="visible" 
        :confirmLoading="loading" 
        @cancel="cancel" 
        @ok="confirm"
>
      <div slot="title">{{ isReadonly ? "查看" : (localForm.id ? "编辑" : "新增") }}</div>
        <div style="max-height: 65vh; overflow-y: auto;border: 1px solid #277fd0 ; overflow-x: hidden;padding: 10px;margin: -10px">
        <a-form-model ref="form" :model="localForm.others" :rules="isReadonly ? {} : rules" :label-col="{ span: 6 }" :wrapper-col="{ span: 16 }">
          <a-form-model-item prop="check_date" label="检查日期">
            <a-date-picker v-model="localForm.others.check_date" format="YYYY-MM-DD" style="width: 100%" :disabled="isReadonly" @change="chooseDate" />
          </a-form-model-item>
          <a-form-model-item prop="control_date" label="管控日期范围">
            <a-range-picker v-model="localForm.others.control_date" :disabled="isReadonly" />
          </a-form-model-item>
          <a-form-model-item prop="record_code" label="记录编号">
            <a-input v-model="localForm.others.record_code" :disabled="isReadonly" />
          </a-form-model-item>
          <a-form-model-item prop="review" label="上周回顾">
            <a-textarea v-model="localForm.others.review" :disabled="isReadonly" />
          </a-form-model-item>
          <a-form-model-item prop="troubleshooting" label="本周排查">
            <a-textarea v-model="localForm.others.troubleshooting" :disabled="isReadonly" />
          </a-form-model-item>
          <a-form-model-item prop="measures" label="整改措施">
            <a-textarea v-model="localForm.others.measures" :disabled="isReadonly" />
          </a-form-model-item>
          <a-form-model-item prop="remark" label="备注">
            <a-textarea v-model="localForm.others.remark" :disabled="isReadonly" />
          </a-form-model-item>
          <a-form-model-item prop="participants" label="参加人员">
            <a-select v-model="localForm.others.participants" mode="multiple" placeholder="请选择参加人员" style="width: 100%" :disabled="isReadonly">
              <a-select-option v-for="item in userList" :key="item.id" :value="item.name">
                {{ item.name }}
              </a-select-option>
            </a-select>
          </a-form-model-item>
        </a-form-model>
      </div>

      <!-- 打印容器 -->
      <div class="weekly-print-container">
        <div id="weeklyPrint">
          <PrintDetail :form="localForm" />
        </div>
      </div>
      
      <template #footer>
        <a-button v-if="localForm.id" key="print" type="primary" v-print="printOptions">
          打印
        </a-button>
        <a-button v-if="!isReadonly" key="submit" type="primary" :loading="loading" @click="confirm">
          {{ localForm.id ? '保存' : '新增' }}
        </a-button>
        <a-button key="cancel" @click="cancel">
          {{ isReadonly ? '关闭' : '取消' }}
        </a-button>
      </template>
    </a-modal>
  </div>
</template>

<script>
import { weekControlAdd, weekControlEdit } from "@/api/control";
import { userList } from "@/api/account"; // 导入获取用户列表的API
import moment from 'moment';
import PrintDetail from "./print-detail.vue";

export default {
  name: "FormModal",
  components: {
    PrintDetail
  },
  props: ["visible", "form", "clientsClassificationOptions", "isReadonly"],
  data() {
    return {
      localForm: { others: {} },
      printOptions: {
        id: "weeklyPrint",
        popTitle: "周排查打印",
        extraHead: "",
      },
      levelOptions: [
        { id: "0", name: "0" },
        { id: "1", name: "1" },
        { id: "2", name: "2" },
        { id: "3", name: "3" },
      ],
      rules: {
        check_date: [
          { required: true, message: "请选择检查日期", trigger: "change" }
        ]
      },
      loading: false,
      userList: [], // 添加用户列表数据
    };
  },
  watch: {
    visible(newVal) {
      if (newVal) {
        this.localForm = JSON.parse(JSON.stringify(this.form));
        this.normalizeDateFields();
      }
    }
  },
  mounted() {
    this.getUserList(); // 组件挂载时获取用户列表
  },
  methods: {
    normalizeDateFields() {
      if (this.localForm && this.localForm.others) {
        if (this.localForm.others.check_date && typeof this.localForm.others.check_date === 'string') {
          this.localForm.others.check_date = moment(this.localForm.others.check_date);
        }
        if (this.localForm.others.control_date) {
          if (typeof this.localForm.others.control_date === 'string') {
            try {
              const dates = JSON.parse(this.localForm.others.control_date);
              if (Array.isArray(dates) && dates.length === 2) {
                this.localForm.others.control_date = [moment(dates[0]), moment(dates[1])];
              }
            } catch (e) {
              console.error('解析管控日期范围失败:', e);
            }
          } else if (Array.isArray(this.localForm.others.control_date)) {
            this.localForm.others.control_date = this.localForm.others.control_date.map(date =>
              typeof date === 'string' ? moment(date) : date
            );
          }
        }
      }
    },
    getUserList() {
      userList({ page_size: 999 }).then(response => {
        this.userList = response.results || []; // 根据API响应格式调整
      }).catch(error => {
        console.error("获取用户列表失败:", error);
      });
    },
    chooseDate(data, dateString) {
      this.localForm.others.check_date = dateString
    },
    confirm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.loading = true;
          const payload = JSON.parse(JSON.stringify(this.localForm));
          if (payload.others) {
            if (payload.others.check_date && typeof payload.others.check_date === 'object') {
              payload.others.check_date = payload.others.check_date.format ? payload.others.check_date.format('YYYY-MM-DD') : String(payload.others.check_date);
            }
            if (Array.isArray(payload.others.control_date)) {
              payload.others.control_date = payload.others.control_date.map(d =>
                d && d.format ? d.format('YYYY-MM-DD HH:mm:ss') : String(d)
              );
            }
          }
          let func = this.localForm.id ? weekControlEdit : weekControlAdd;
          func(payload)
            .then(() => {
              this.$message.success(this.localForm.id ? "修改成功" : "新增成功");
              this.$emit(this.localForm.id ? "update" : "create");
              this.cancel();
            })
            .finally(() => {
              this.loading = false;
            });
        }
      });
    },
    cancel() {
      this.$emit("cancel", false);
      if (!this.localForm.id) {
        this.$refs.form.resetFields();
      }
    },
  },
};
</script>

<style lang="less" scoped>
.weekly-print-container {
  position: absolute;
  left: -9999px;
  top: 0;
  visibility: hidden;
}
</style>
